import { LinearProgress } from '@mui/material';
import MainCard from 'components/ui/Card/MainCard';
import WorkflowExecutionForm, {
    PostExecutionPathProps,
} from 'components/features/workflowExecutions/WorkflowExecutionForm';
import { findWorkflowTagValue, WorkflowTagCategory } from 'utils/workflow';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { workflowExecutionDetailsPath } from 'routes/paths';
import { DagDetailParams, useGetDagDetailsQuery, useGetDagRunQuery } from 'store/airflow/enhancedAirflowApi';

export default function ReExecute() {
    const methods = useForm();
    const [schemaDagRunData, setSchemaDagRunData] = useState<object | undefined>(undefined);

    const { workflowExId, workflowId } = useParams();

    const { data: dagDetailsData, isLoading: dagDetailsIsLoading } = useGetDagDetailsQuery({
        dagId: workflowId as string,
    });

    const { data: dagRun, isLoading: dagRunIsLoading } = useGetDagRunQuery({
        dagId: workflowId as string,
        dagRunId: workflowExId as string,
    });

    useEffect(() => {
        const schemaNameExists = Object.keys(dagDetailsData?.params || {}).some(
            key => dagDetailsData?.params?.[key]?.schema?.schema_name
        );

        const newObject = schemaNameExists
            ? (function () {
                  const copiedObject = JSON.parse(JSON.stringify(dagDetailsData?.params || {}));

                  if (dagRun?.conf && typeof dagRun.conf === 'object') {
                      Object.keys(dagRun.conf).forEach(key => {
                          if (copiedObject[key]?.schema?.schema_name && !key.includes('token')) {
                              copiedObject[key] = {
                                  ...copiedObject[key],
                                  value: dagRun?.conf?.[key],
                              };
                          }
                      });
                  }

                  return copiedObject;
              })()
            : null;

        newObject && setSchemaDagRunData(newObject);
    }, [dagDetailsData?.params, dagRun?.conf]);

    const createPostExecutionPath = ({ workflowExId, workflowId }: PostExecutionPathProps): string =>
        workflowExecutionDetailsPath(workflowId, workflowExId);

    return (
        <MainCard>
            {dagDetailsIsLoading || dagRunIsLoading ? (
                <LinearProgress />
            ) : (
                <>
                    <FormProvider {...methods}>
                        <WorkflowExecutionForm
                            projectShortName={findWorkflowTagValue(dagDetailsData, WorkflowTagCategory.PROJECT)}
                            originalParams={(schemaDagRunData ?? dagRun?.conf) as DagDetailParams}
                            postExecutionPath={createPostExecutionPath}
                            autoselectInputPath
                        />
                    </FormProvider>
                </>
            )}
        </MainCard>
    );
}
